import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
  CheckIconComponent,
  ErrorIconComponent,
  ModalComponent
} from 'remarketing-ui-components-lib';
import {
  Configuration,
  EditPostingState,
  SetBookValueRecalculationNotNeeded,
  SetChromeDataInput,
  SetDisplayedBookValues,
  SetInitialPosting,
  SetSkipNavigationGuard,
  NewPostingInspectionOption,
  PostingTypes
} from 'remarketing-angular-library';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngxs/store';
import {Router} from '@angular/router';
import {cloneDeep} from 'lodash';
import {SaComponent} from 'smartauction-frontend-micro-library';
import { EditPostingUtilsService } from '../../services/edit-posting-utils.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-posting-success-modal',
    templateUrl: './posting-success-modal.component.html',
    styleUrls: ['./posting-success-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, CheckIconComponent, ErrorIconComponent, CommonModule]
})
export class PostingSuccessModalComponent extends SaComponent implements OnInit {
  @Input() content?: string;
  @Input() heading?: string;
  @Input() postingType: PostingTypes;
  @Input() warningContent?: string;
  @Input() vin: string;
  @Input() inspectionType?: NewPostingInspectionOption;
  // Initialize so we can use Enum values in template.
  postingTypes = PostingTypes;
  configuration: Configuration;
  readonly newPostingInspectionOption = NewPostingInspectionOption;

  @ViewChild(ModalComponent) modal: ModalComponent;

  constructor(
    private readonly store: Store,
    private readonly router: Router,
    private readonly editPostingUtilsService: EditPostingUtilsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.store
      .select(state => state.configuration.configuration)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(configuration => (this.configuration = configuration));
  }

  show() {
    this.modal.show();
  }

  close() {
    const postingData = cloneDeep(this.store.selectSnapshot(EditPostingState.updatedPosting));
    this.store.dispatch(new SetInitialPosting(postingData));
    this.store.dispatch(new SetSkipNavigationGuard(false));
    this.modal.close();
  }

  closeAndRedirect(route: string) {
    this.editPostingUtilsService.clearFailedValidationFormsArray();
    this.store.dispatch(new SetBookValueRecalculationNotNeeded());
    this.store.dispatch(new SetDisplayedBookValues(undefined));
    this.store.dispatch(new SetSkipNavigationGuard(true));
    this.store.dispatch(new SetChromeDataInput(undefined));
    this.modal.close();
    this.router.navigate([route]);
  }
}
